import React, { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

import { isUSRegionSelector, useRegionStore } from '@packages/stores';

import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { closeModalSelector, openModalSelector, useModalStore } from '@store';
import { sendAnalyticsEvent, testProps } from '@utils';

type Props = {
  className?: string;
};

export const ExcessAmount: React.FC<Props> = ({ className }) => {
  const isUS = useRegionStore(isUSRegionSelector);
  const openModal = useModalStore(openModalSelector);
  const closeModal = useModalStore(closeModalSelector);

  const handleModalOpen = useCallback(() => {
    sendAnalyticsEvent('Excess Modal Clicked');
    openModal('Modal', {
      body: {
        type: 'ExcessModal',
      },
      size: 'lg',
      actionContainerClassName: 'sm:px-6 sm:pt-0  sm:mt-0',
      actions: [
        {
          title: 'OK',
          variant: 'primary',
          onClick: () => {
            closeModal();
          },
        },
      ],
    });
  }, [closeModal, openModal]);

  if (isUS) {
    return null;
  }

  return (
    <div className={twMerge('flex flex-row  cursor-pointer', className)}>
      <Text variant="h4-24/sb" {...testProps('benefits-excess-amount')} onClick={handleModalOpen}>
        {i18n.t('myQuote.excess.title')}
      </Text>
      <Button
        className="mt-0.5"
        variant="tertiary"
        size="sm"
        icon="info"
        onClick={handleModalOpen}
      />
    </div>
  );
};
